
import { defineComponent } from 'vue'
import Counter from './components/Counter.vue'
import { useCounters } from './compositions/counter'

export default defineComponent({
  name: 'App',
  components: {
    Counter
  },
  setup() {
    return {
      ...useCounters()
    }
  }
})
